import { render, staticRenderFns } from "./ActionIcon.vue?vue&type=template&id=0cfc5938&scoped=true"
import script from "./ActionIcon.vue?vue&type=script&lang=js"
export * from "./ActionIcon.vue?vue&type=script&lang=js"
import style0 from "./ActionIcon.vue?vue&type=style&index=0&id=0cfc5938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfc5938",
  null
  
)

export default component.exports